import { Controller } from '@hotwired/stimulus';
import { show, toggleVisiblity } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['newsletterSubscription', 'filterCta'];
  static classes = ['stickyForm', 'activeFilterCta'];

  connect() {
    this.setFilterActive(this.filterCtaTargets[0]);
    dispatchCustomEvent('form-overlay:set-heading', { heading: 'Wähle weitere Newsletter und trage dich ein' });
  }

  selectFilter(event) {
    const filterValue = event.currentTarget.dataset.filterValue;
    this.setFilterActive(event.currentTarget);

    if (filterValue == 'all') {
      this.newsletterSubscriptionTargets.forEach((target) => show(target));
    } else {
      this.newsletterSubscriptionTargets.forEach((target) => {
        toggleVisiblity(
          target,
          target.dataset.newsletterSubscriptionType == filterValue
        );
      });
    }
  }

  setFilterActive(cta) {
    this.filterCtaTargets.forEach((target) =>
      target.classList.remove(this.activeFilterCtaClass)
    );
    cta.classList.add(this.activeFilterCtaClass);
  }
}
